 
export class KonkurrenceDelopgaveAfslutningstidspunkt {
        public konkurrenceId: string;
        public delopgaveId: string;
        public varighed: number;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/KonkurrenceDelopgaveAfslutningstidspunkt.ts